
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');
var Template = require('./../../../../skins/newbettingterminal-betwym.betconstruct.com/terminal/components/gameListAsian/template.js');

/* eslint-disable no-trailing-spaces */
import { Component } from "react";
import { connect } from "react-redux";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { getSwarmSubscriptionRequestGameListAsian, getSwarmSubscriptionRequestGameMarketsCountAsian } from "../../../helpers/terminalRequests/gameListAlias";
import { getBoostedOdds } from '../../../helpers/terminalRequests/boostedOdds';
import { handleGameListAsianSubscriptionData, handleFavoriteGameListSubscriptionData } from "../../../helpers/asianHelpers";
import { AsianGamesListUpdateReceived, ResetAsianGamesList, ToggleListByDate } from "../../../actions/asianActions";
import { createSelector } from "reselect";
import { getAsianGameListData, getAsianGameListDataForAllSports, getAsianGameUsa } from '../../../helpers/asianGameListSelector';
import PropTypes from "prop-types";
import { UIMixin } from "../../../mixins/uiMixin";
import Config from "../../../config/main";
import { browserHistory } from 'react-router';
import { getSportListSubscriptionRequest } from "@app/dev/helpers/asianHelpers/requests";
import { getBetBuilder } from "../../../helpers/terminalRequests/betBuilder";
class GameListAsian extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gameLoadCount: 20
        };
        this.scroll = this.scroll.bind(this);
        this.handleScrollListener = this.handleScrollListener.bind(this);
        this.hendlerCheckBoxSortDate = this.hendlerCheckBoxSortDate.bind(this);
    }
    scroll(scrollSize) {
        return () => {
            this.scrollGamesListAsian.scrollTop += (scrollSize);
        };
    }
    hendlerCheckBoxSortDate(e) {
        this.props.dispatch(ToggleListByDate());
    }
    handleScrollListener(e) {
        if (!this.props.data) return;

        const { scrollHeight, clientHeight, scrollTop } = e.target;
        const { gameLoadCount } = this.state;
        let gameCounts = 0;


        if (this.props.byDayeSort && !Array.isArray(this.props.data))
            gameCounts = Object.values(this.props.data).reduce((acc, item) => acc + item.length, 0);
        else if (this.props.sportAlias === 'all' || this.props.sportAlias === "boosted" || this.props.sportAlias === "betBuilder" )
            gameCounts = this.props.data.reduce((sum, current) => sum + current.data.reduce((sum, current) => sum + current[current.key].length, 0), 0);
        else
            gameCounts = this.props.data.reduce((sum, current) => sum + current[current.key].length, 0);

        if (scrollHeight - clientHeight - scrollTop < 30 && gameLoadCount < gameCounts) {
            this.setState({ gameLoadCount: gameLoadCount + 20 });
        }
    }
    componentDidUpdate() {
        if (this.props.data) {
            if (this.props.data.length === 0 && this.props.firstSportAlias) {
                const redirectSportAlias = this.props.firstSportAlias

                browserHistory.push(`/${this.props.gameType}/${redirectSportAlias}/all/all`)
            }
            const scrollPos = JSON.parse(sessionStorage.getItem('scrollPos'));
            if (scrollPos && history.state && scrollPos[history.state.key]) {
                this.scrollGamesListAsian.scrollTop = scrollPos[history.state.key];
            }
        }
    }
    componentWillUnmount() {
        this.props.dispatch(ResetAsianGamesList(this.props.selectorKey));
    }

    render() {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

GameListAsian.propTypes = {
    selectorKey: PropTypes.string,
    marketsSelectorKey: PropTypes.string,
    data: PropTypes.array,
    marketsData: PropTypes.object,
    loaded: PropTypes.bool,
    dataLength: PropTypes.number,
    timeFilter: PropTypes.any,
    uiClose: PropTypes.func,
    ToggleListByDate: PropTypes.func
};

const mapStateToProps = (_, ownParams) => {
    let { sportAlias, gameType, regionId, competitionId, timeFilter, boostedOddsGameIds, betBuilderGameIds } = ownParams;
    let key;
    let marketsKey;

    let sportListSwarmKey = getSwarmDataKeyForRequest(getSportListSubscriptionRequest(gameType, timeFilter, null, null));
    if (sportAlias === "betBuilder") {
        key = getSwarmDataKeyForRequest(getBetBuilder(betBuilderGameIds, gameType),);
        marketsKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameMarketsCountAsian(null, gameType, +regionId, +competitionId, timeFilter, betBuilderGameIds));
    } else if (sportAlias === "boosted") {
        const boostedOddsGameIdsArr = boostedOddsGameIds && Object.keys(boostedOddsGameIds).slice(0, 50).map(item => +item);
        key = getSwarmDataKeyForRequest(getBoostedOdds(boostedOddsGameIds, gameType));
        marketsKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameMarketsCountAsian(null, gameType, +regionId, +competitionId, timeFilter, boostedOddsGameIdsArr));
    } else {
        key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameListAsian(sportAlias, gameType, regionId, +competitionId, timeFilter));
        marketsKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameMarketsCountAsian(sportAlias, gameType, +regionId, +competitionId, timeFilter));
    }
    return createSelector(
        [
            state => state.asianGameList.byDayeSort,
            state => state.swarmData.loaded[key],
            state => state.asianGameList[key] && JSON.stringify(sportAlias === 'all' || sportAlias === "boosted" || sportAlias === "betBuilder" ? getAsianGameListDataForAllSports(state.asianGameList[key], state.asianGameList.byDayeSort)
                : Config.enableUsaSortByDate ? getAsianGameUsa(state.asianGameList[key], state.asianGameList.byDayeSort) : getAsianGameListData(state.asianGameList[key], state.asianGameList.byDayeSort)),
            state => state.asianGameList[marketsKey] && JSON.stringify(state.asianGameList[marketsKey]),
            state => state.swarmData.data[sportListSwarmKey]?.[0]?.alias,
        ],
        (byDayeSort, loaded, data, marketsData, firstSportAlias) => {
            return {
                byDayeSort,
                loaded,
                firstSportAlias,
                data: data && JSON.parse(data),
                marketsData: marketsData && JSON.parse(marketsData),
                selectorKey: key,
                marketsSelectorKey: marketsKey
            };
        });
};

export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: UIMixin({ Component: GameListAsian }),
        ComponentWillMount: function () {
            let { sportAlias, gameType, regionId, competitionId, timeFilter, boostedOddsGameIds, betBuilderGameIds } = this.props;
            const boostedOddsGameIdsArr = boostedOddsGameIds && Object.keys(boostedOddsGameIds).slice(0, 50).map(item => +item);

            if (sportAlias === "betBuilder") {
                this.swarmSubscriptionRequests = [
                    getBetBuilder(betBuilderGameIds, gameType),
                    getSwarmSubscriptionRequestGameMarketsCountAsian(null, gameType, +regionId, +competitionId, timeFilter)
                ];

                this.swarmDataKeys = [
                    getSwarmDataKeyForRequest(getBetBuilder(betBuilderGameIds, gameType)),
                    getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameMarketsCountAsian(null, gameType, +regionId, +competitionId, timeFilter, betBuilderGameIds))
                ];
            } else if (sportAlias === 'boosted') {
                this.swarmSubscriptionRequests = [
                    getBoostedOdds(boostedOddsGameIds, gameType),
                    getSwarmSubscriptionRequestGameMarketsCountAsian(null, gameType, +regionId, +competitionId, timeFilter, boostedOddsGameIdsArr)
                ];

                this.swarmDataKeys = [
                    getSwarmDataKeyForRequest(getBoostedOdds(boostedOddsGameIds, gameType)),
                    getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameMarketsCountAsian(null, gameType, +regionId, +competitionId, timeFilter, boostedOddsGameIdsArr))
                ];
            } else {
                this.swarmSubscriptionRequests = [
                    getSwarmSubscriptionRequestGameListAsian(sportAlias, gameType, regionId, +competitionId, timeFilter),
                    getSwarmSubscriptionRequestGameMarketsCountAsian(sportAlias, gameType, +regionId, +competitionId, timeFilter)
                ];

                this.swarmDataKeys = [
                    getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameListAsian(sportAlias, gameType, regionId, +competitionId, timeFilter)),
                    getSwarmDataKeyForRequest(getSwarmSubscriptionRequestGameMarketsCountAsian(sportAlias, gameType, +regionId, +competitionId, timeFilter))
                ];
            }

            this.meta = {
                simplify: true,
                preventOriginalAction: true,
                finalize: (loaded, dataKey) => {
                    const [gameListDataKey] = this.swarmDataKeys;

                    return dataKey === gameListDataKey ? {
                        additionalActions: [AsianGamesListUpdateReceived.bind(null, sportAlias === 'all' || sportAlias === "boosted" || sportAlias === "betBuilder" ? handleFavoriteGameListSubscriptionData(loaded) : handleGameListAsianSubscriptionData(loaded, { alias: sportAlias }))]
                    } : {
                        additionalActions: [AsianGamesListUpdateReceived.bind(null, loaded, dataKey)]
                    };
                }
            };
        }
    }
));